var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollapseRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.2 3.6C1.2 2.27452 2.27452 1.2 3.6 1.2H5.39999C5.73136 1.2 5.99999 0.931371 5.99999 0.6C5.99999 0.268629 5.73136 0 5.39999 0H3.6C1.61177 0 0 1.61178 0 3.6V14.4C0 16.3882 1.61178 18 3.6 18H5.39999C5.73136 18 5.99999 17.7314 5.99999 17.4C5.99999 17.0686 5.73136 16.8 5.39999 16.8H3.6C2.27452 16.8 1.2 15.7255 1.2 14.4V3.6ZM13.5743 4.32564C13.3399 4.09132 12.96 4.09132 12.7257 4.32564C12.4914 4.55995 12.4914 4.93985 12.7257 5.17417L15.9515 8.3999H7.6C7.26863 8.3999 7 8.66853 7 8.9999C7 9.33127 7.26863 9.5999 7.6 9.5999H15.9515L12.7257 12.8256C12.4914 13.06 12.4914 13.4399 12.7257 13.6742C12.96 13.9085 13.3399 13.9085 13.5743 13.6742L17.8243 9.42417C18.0586 9.18985 18.0586 8.80995 17.8243 8.57564L13.5743 4.32564Z",
    fill: "#70797B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseRight);
export default __webpack_public_path__ + "static/media/collapse-right.b921fa3b521023915c234f76b97242aa.svg";
export { ForwardRef as ReactComponent };